import customFetch from "./axios";
import { normalizeApiResponse } from "./apiUtils";

/**
 * Obtiene del backend los datos actuales del usuario preservando los tokens actuales.
 * @param {Object} currentUser
 * @returns {Promise<Object>} usuario actualizado o el mismo currentUser si no hay cambios/errores
 */
export async function fetchCurrentUser(currentUser) {
  try {
    const currentAccessToken = currentUser.access;
    const currentRefreshToken = currentUser.refresh;
    const headers = currentAccessToken
      ? { headers: { Authorization: `Bearer ${currentAccessToken}` } }
      : {};

    let fresh = null;

    if (currentUser?.id) {
      try {
        const byId = await customFetch.get(`/api/users/${currentUser.id}/`, headers);
        if (byId?.data) fresh = byId.data;
      } catch (_) { /* ignore and fallback */ }
    }

    if (!fresh && currentUser?.email) {
      try {
        const byEmail = await customFetch.get(`/api/users/?email=${encodeURIComponent(currentUser.email)}`, headers);
        const normalized = normalizeApiResponse(byEmail?.data);
        fresh = normalized.results?.[0] || null;
      } catch (_) { /* ignore */ }
    }

    if (fresh) {
      // Mantener tokens actuales y comparar cambios "reales"
      const candidate = {
        ...fresh,
        access: currentAccessToken,
        refresh: currentRefreshToken || currentUser.refresh,
      };

      // Igualdad profunda ignorando diferencias de referencia
      const safeStringify = (obj) => {
        try { return JSON.stringify(obj); } catch { return ""; }
      };

      // Si no cambió nada relevante, devolver la misma referencia
      if (safeStringify(candidate) === safeStringify(currentUser)) {
        return currentUser;
      }
      return candidate;
    }
    return currentUser;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return currentUser;
  }
}
